import React, { useState, useEffect, useCallback } from "react";
import { DefaultFontStack } from "../typography/typography";
import styled from "styled-components";

const PageTitleText = styled.h1`
  ${DefaultFontStack}
  font-size: 32px;
  text-transform: uppercase;
  font-weight: 700;
  color: ${(props) => props.theme.colors.highEmphasis};
  letter-spacing: 1.75px;
  display: inline;
  margin: 0px;
`;

const Container = styled.div`
  position: relative;
  margin-top: 0px;
  margin-bottom: 0px;
`;
const Accent = styled.div`
  height: 25px;
  background-color: ${(props) => props.theme.colors.ice};
  left: -${(props) => props.$textOffset}px;

  width: ${(props) =>
    props.$textWidth ? `${props.$textWidth + props.$textOffset}px` : "unset"};
  top: ${(props) =>
    props.$textHeight ? `${props.$textHeight - 35 / 2}px` : "unset"};
  ${(props) => props.theme.breakpoints.up("tablet")} {
    width: ${(props) =>
      props.$textWidth
        ? `${props.$textWidth + props.$textOffset + 30}px`
        : "unset"};
    top: ${20}px;
  }
  position: absolute;
  z-index: -1;
`;

const PageTitle = ({ className, children }) => {
  const [textNode, setTextNode] = useState();
  const [textWidth, setTextWidth] = useState();
  const [textHeight, setTextHeight] = useState();
  const [textOffset, setTextOffset] = useState();

  const titleRef = useCallback((node) => {
    if (node !== null) {
      setTextNode(node);
      setTextHeight(node.getBoundingClientRect().height);
      setTextWidth(node.getBoundingClientRect().width);
      setTextOffset(node.getBoundingClientRect().left);
    }
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (textNode) {
        setTextOffset(textNode.getBoundingClientRect().left);
        setTextHeight(textNode.getBoundingClientRect().height);
        setTextWidth(textNode.getBoundingClientRect().width);
      }
    };

    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [textNode]);

  return (
    <Container className={className}>
      <PageTitleText ref={titleRef}>{children}</PageTitleText>
      <Accent
        $textWidth={textWidth}
        $textOffset={textOffset}
        $textHeight={textHeight}
      />
    </Container>
  );
};

export default styled(PageTitle)``;
